import React from "react";

const SuperAdminHome = () => {
  return (
    <>
      <br></br>

      <div className="text-center m-5 bg-success text-white">
        <br></br>
        <img
          src="/logo.png"
          alt="LOGO"
          className="img-fluid"
          style={{ width: "250px" }}
        ></img>
        <h2>Welcome To Admin Panel</h2>
        <h5>
          <strong>
            Venkateshwara Farmer Welfare Foundation.
          </strong>
        </h5>

        <br></br>
      </div>
    </>
  );
};

export default SuperAdminHome;
